import { useViewData } from "../view-data";
import { useFilterOptionPmsActiveListQueryDataBySearchParams } from "./use-filter-option-pms-active-list-by-search-params";
import { useHandleFilterByOption } from "./use-handle-filter-by-option";

import type * as Repository from "../../../_repository";

type Props = {
	optionPmsOptionListQueryData: Repository.Query.QueryData.OptionPmsOptionListQueryData;
	optionPmsActiveListQueryData: Repository.Query.QueryData.OptionPmsList.OptionPmsActiveListQueryData;
};

export const useInitialized = ({ optionPmsOptionListQueryData, optionPmsActiveListQueryData }: Props) => {
	const {
		// オプション ID（表示するオプション）
		displayOptionIdList,
		//
		// 全てのオプションを表示
		onDisplayAllOption,
		// 全てのオプションを非表示
		onHideAllOption,
		// 表示するオプションの追加
		onAddDisplayOption,
		// 表示するオプションの削除
		onRemoveDisplayOption,
	} = useHandleFilterByOption();

	/**
	 * ViewData の生成
	 */
	const { viewData } = useViewData({ optionPmsOptionListQueryData, displayOptionIdList });

	/**
	 * 表示するオプションの絞り込み
	 */
	const { filteredOptionPmsActiveListQueryData } = useFilterOptionPmsActiveListQueryDataBySearchParams({
		optionPmsActiveListQueryData,
		viewData,
	});

	return {
		//
		viewData,
		filteredOptionPmsActiveListQueryData,
		//
		// 全てのオプションを表示
		onDisplayAllOption,
		// 全てのオプションを非表示
		onHideAllOption,
		// 表示するオプションの追加
		onAddDisplayOption,
		// 表示するオプションの削除
		onRemoveDisplayOption,
	};
};
